export type StoreyElementsVisibility = {
  [id: string]: boolean
}

export enum EventType {
  StoreyElementVisibilityChanged = 'StoreyElementVisibilityChanged',
  CodeValidationNewDataFetch = 'CodeValidationNewDataFetch',
  CodeValidationAnimationFinished = 'CodeValidationAnimationFinished',
  CodeValidationClustersUpdated = 'CodeValidationClustersUpdated',
  CodeValidationClustersViewUpdated = 'CodeValidationClustersViewUpdated',
  BuildingRemoveElement = 'BuildingRemoveElement',
  BuildingAddWallElement = 'BuildingAddWallElement',
  BuildingAddWindowElement = 'BuildingAddWindowElement',
  BuildingAddDoorElement = 'BuildingAddDoorElement',
  BuildingAddStructuralElement = 'BuildingAddStructuralElement',
  BuildingEditWallElement = 'BuildingEditWallElement',
  BuildingEditWindowElement = 'BuildingEditWindowElement',
  BuildingEditDoorElement = 'BuildingEditDoorElement',
  BuildingEditStructuralElement = 'BuildingEditStructuralElement',
  BuildingMoveRoofElement = 'BuildingMoveRoofElement',
  BuildingSnapWallElements = 'BuildingSnapWallElements',
  BuildingCreateBuilding = 'BuildingCreateBuilding',
  StructuralAutomationFinished = 'StructuralAutomationFinished',
  ReplaceBuildingElementOnBimObject = 'ReplaceBuildingElementOnBimObject',
}

type Listener = (event?: any) => void

class EventEmitter {
  private listeners: { [key: string]: Listener[] } = {}

  on(event: string, listener: Listener) {
    if (!this.listeners[event]) {
      this.listeners[event] = []
    }
    this.listeners[event].push(listener)
  }

  off(event: string, listener: Listener) {
    if (!this.listeners[event]) return

    this.listeners[event] = this.listeners[event].filter((l) => l !== listener)
  }

  emit(event: string, payload?: any) {
    if (!this.listeners[event]) return

    this.listeners[event].forEach((listener) => listener(payload))
  }

  dispose() {
    this.listeners = {}
  }
}

export default EventEmitter
